"use strict";

var GoogleCalendarLoading = React.createClass({
  render: function() {
    return (
      <div>
        <div className="mb40 bootstrap-agendor">
          <h3 className="mb-20 p-r">Integração Agendor ↔ Google Agenda</h3>
          <div className="fieldContent">
            <div className="fl right-gray-border integration-logo ">
                <img className="googleCalendar-loading-logo" src="/skins/sistema/page/integracoes/imagens/google-calendar.png" />
            </div>
            <div className="left-gray-border integrationGuide">
              <ul>
                <li className="googleCalendar-loading-description w-300 mb-15 mt-5"></li>
                <li className="googleCalendar-loading-description w-400 mb-10"></li>
                <li className="googleCalendar-loading-description w-350 mb-10"></li>
              </ul>
              <div className="mt-80"></div>
            </div>
          </div>
        <div className="googleCalendar-loading-opacity"></div>
        </div>
      </div>
    );
  }
});

module.exports = GoogleCalendarLoading;



// WEBPACK FOOTER //
// ./app/screens/Integration/components/GoogleCalendar/google-calendar-loading.jsx